"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _Panel = _interopRequireDefault(require("../Tabs/Panel"));

var _default = _Panel.default;
exports.default = _default;